module.exports = __webpack_public_path__ + "static/media/how-to-mob.cd85563f.png";